import script from "./ApiDocLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiDocLayout.vue?vue&type=script&setup=true&lang=js"

import "./ApiDocLayout.vue?vue&type=style&index=0&id=6038a150&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6038a150"]])

export default __exports__